// extracted by mini-css-extract-plugin
export default {"container":"react-table_container__2FI8l","table":"react-table_table__qNYXn","noData":"react-table_noData__Tk2-u"};